
import { toast as sonnerToast } from 'sonner';
import { ToastProps as ShadcnToastProps } from "@/components/ui/toast";

export type ToastProps = ShadcnToastProps;

export interface ToastOptions {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'destructive' | 'success' | 'warning';
}

export type ToastActionElement = React.ReactElement<typeof import('@/components/ui/toast').ToastAction>;

// Create a toast function that is callable and has methods
const toastFunction = (options: ToastOptions) => sonnerToast(options.title, { description: options.description });

// Add methods to the function
export const toast = Object.assign(toastFunction, {
  default: (options: ToastOptions) => sonnerToast(options.title, { description: options.description }),
  error: (options: ToastOptions) => sonnerToast.error(options.title, { description: options.description }),
  success: (options: ToastOptions) => sonnerToast.success(options.title, { description: options.description }),
  warning: (options: ToastOptions) => sonnerToast(options.title, { description: options.description, className: 'bg-yellow-500' }),
  info: (options: ToastOptions) => sonnerToast.info(options.title, { description: options.description }),
});

// Export a useToast hook for shadcn/ui compatibility
export function useToast() {
  return {
    toast,
    toasts: [] // Provide empty toasts array for compatibility
  };
}
